'use strict';

import navbarTemplate from './navbar.directive.html';

export default angular
  .module('maestro.directives.semantic.navbar', [])

  .directive('navbar', function($rootScope) {
    return {
      restrict: 'E',
      bindToController: true,
      controllerAs: '$ctrl',
      template: navbarTemplate,
      require: '?tabs',
      replace: true,
      scope: {
        tabs: '=', // Array<{id: string, name: string, icon: string, hidden: boolean, silent: boolean}>
        activeTabExternal: '=activeTab', // {tab: string, name: string, icon: string, hidden: boolean, silent: boolean}
        isDisabled: '=disabled',
        class: '@'
      },
      controller: function($scope, $element, $state, $timeout) {
        const ctrl = this;
        let activeTabInternal;

        ctrl.mobileMenuExpanded = false;
        ctrl.currentTab = void 0;
        ctrl.lastNotHiddenTab = void 0;

        // Calculations for tabs width
        ctrl.moreTabs = []; // array of tabs that should go to 'more' dropdown
        let tabDimensions;

        // More tabs dropdown initiatisation
        $('#more-tabs').dropdown({
          keepOnScreen: false,
          action: 'hide',
          on: 'hover',
          onChange: (tabId) => {
            $scope.$applyAsync(() => {
              ctrl.chooseTab(tabId);
            });
          }
        });

        $scope.$on('$stateChangeSuccess', function() {
          if ($state.params.tab === activeTabInternal) {
            return;
          }
          processExternalTabChange($state.params.tab);
        });

        $scope.$watch('$ctrl.activeTabExternal', (newParams, oldParams) => {
          if (newParams == oldParams) {
            return;
          }
          processExternalTabChange(ctrl.activeTabExternal);
        });

        $scope.$watch('$ctrl.tabs', (newParams, oldParams) => {
          processExternalTabChange(activeTabInternal || ctrl.activeTabExternal || $state.params.tab);

          const previousVisibleIds = (ctrl.tabsFiltered || []).map(t => t.id).join(',');
          ctrl.tabsFiltered = ctrl.tabs ? ctrl.tabs.filter(t => !t.hidden) : [];
          const currentVisibleIds = ctrl.tabsFiltered.map(t => t.id).join(',');

          // Re-bind Semantic UI tab handlers when the set of visible tabs changes.
          if (previousVisibleIds !== currentVisibleIds) {
            $timeout(() => ctrl.initSemanticTabs(), 0);
          }
        }, true);

        $rootScope.$watch('isMobileView', function(newValue, oldValue) {
          if (newValue !== undefined) {
            ctrl.isMobileView = $rootScope.isMobileView;
            if (!newValue && ctrl.mobileMenuExpanded) {
              ctrl.toggleMenu();
            }
          }
        });

        $(window).on('resize', function() {
          $scope.$applyAsync(() => {
            processTabsGrouping();
          });
        });

        /**
         * Group tabs if they not fit into screen
         */
        function processTabsGrouping() {
          ctrl.moreTabs = [];
          ctrl.tabs.forEach((tab) => tab.more = false);

          if ($rootScope.isMobileView) {
            return;
          }

          if (!$($element).is(':visible')) {
            return;
          }

          if (!tabDimensions) { // calculate width of each tab only once
            tabDimensions = {};
            $($element).find('#tabs.item.ng-scope').toArray().forEach(el => {
              tabDimensions[el.dataset.tab] = el.clientWidth;
            });
          }
          let moreButtonWidth = $($element).find('#more-tabs')[0].clientWidth;

          let containerWidth = $($element)[0].clientWidth;
          let tabsSummaryWidth = 0;
          ctrl.tabs
            .filter(tab => !tab.hidden)
            .forEach((tab) => {
              tabsSummaryWidth += tabDimensions[tab.id] ? parseInt(tabDimensions[tab.id]) : 0;
              tab.more = tabsSummaryWidth + (moreButtonWidth || 50) + 10 > containerWidth;
              if (tab.more) {
                ctrl.moreTabs.push(tab);
              }
            });
        }

        /**
         * Process new tab came from outside
         * @param {string} externalTabId
         */
        function processExternalTabChange(externalTabId) {
          if (!ctrl.tabs || ctrl.tabs.length <= 0) {
            activeTabInternal = externalTabId;
            return;
          }

          if (!externalTabId) {
            // Default tab
            externalTabId = ctrl.tabs[0].id;
          }

          // The tab has really changed
          if (externalTabId !== activeTabInternal) {
            activeTabInternal = externalTabId;
          }

          chooseCurrentTab(activeTabInternal);

          setTabStateParam();

          if (ctrl.activeTabExternal !== activeTabInternal) {
            ctrl.activeTabExternal = activeTabInternal;
          }

          $($element).find('.item').tab('change tab', activeTabInternal);
        }

        function setTabStateParam() {
          if (!ctrl.lastNotHiddenTab) {
            return;
          }

          if ($state.params.tab === ctrl.lastNotHiddenTab.id) {
            return;
          }

          let stateParams = angular.copy($state.params) || {};
          stateParams.tab = ctrl.lastNotHiddenTab.id;

          return $state.go($state.current.name, stateParams, {
            location: 'replace',
            notify: false,
            reload: false
          });
        }

        function chooseCurrentTab(tabId) {
          if (ctrl.currentTab && ctrl.currentTab.id === tabId) {
            return;
          }
          let tab = ctrl.tabs.find(el => el.id === tabId);
          if (tab.hidden && ctrl.currentTab && !ctrl.currentTab.hidden) {
            ctrl.lastNotHiddenTab = ctrl.currentTab;
            if (tab.silent) {
              // Remove tab selection
              $($element).find('.item.active').removeClass('active');
            }
          } else if (!tab.hidden) {
            ctrl.lastNotHiddenTab = tab;
          }
          ctrl.currentTab = tab;
        }

        ctrl.initSemanticTabs = () => {
          let navigationElements = $($element).find('.item');
          navigationElements.tab({
            onVisible: function(tabPath) {
              $scope.$applyAsync(() => {
                processExternalTabChange(tabPath);
              });
            }
          });
          if (activeTabInternal) {
            navigationElements.tab('change tab', activeTabInternal);
          }

          processTabsGrouping();
        };

        ctrl.toggleMenu = () => {
          ctrl.mobileMenuExpanded = !ctrl.mobileMenuExpanded;
        };

        ctrl.chooseTab = (tabPath) => {
          let navigationElements = $($element).find('.item');
          navigationElements.tab('change tab', tabPath);
        };

      }
    };
  })

  .name;
